import { useState } from 'react';
import UserService from '../Services/UserService';
import type { 
  WorkLocationAndAssignmentUpdate, 
  WorkAssignmentRead 
} from '../../Types/schema-helpers';

export const useUserWorkAssignment = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  /**
   * Sends unified location and work assignment updates to the backend via UserService.
   */
  const updateWorkAssignment = async (
    payload: WorkLocationAndAssignmentUpdate,
    locationIdOverride?: string
  ): Promise<WorkAssignmentRead> => {
    setLoading(true);
    setError(null);
    try {
      const updatedAssignment = await UserService.updateProWorkLocationAndAssignment(
        payload,
        locationIdOverride
      );
      return updatedAssignment;
    } catch (err: any) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateWorkAssignment,
    loading,
    error,
  };
};